(() => {
  if (window.BHCartUI?.version === '2026.08.22.1') return;

  const mobileQuery = window.matchMedia('(max-width: 749px)');
  const LAST_PRODUCT_KEY = 'bh:last-product-page';
  const RETURN_PRODUCT_KEY = 'bh:return-to-product';

  function safeStorage(storage, method, key, value) {
    try {
      return value === undefined ? storage[method](key) : storage[method](key, value);
    } catch (_) {
      return null;
    }
  }

  function productUrl(variantId) {
    if (!/\/products\//.test(window.location.pathname)) return '';
    const url = new URL(window.location.href);
    const selectedVariant = variantId || url.searchParams.get('variant');
    const cleanUrl = new URL(url.pathname, window.location.origin);
    if (selectedVariant) cleanUrl.searchParams.set('variant', selectedVariant);
    return `${cleanUrl.pathname}${cleanUrl.search}`;
  }

  function rememberProductPage(variantId) {
    const url = productUrl(variantId);
    if (!url) return;
    safeStorage(localStorage, 'setItem', LAST_PRODUCT_KEY, JSON.stringify({
      url,
      scrollY: Math.max(0, Math.round(window.scrollY || 0)),
      savedAt: Date.now()
    }));
  }

  function getLastProductPage() {
    try {
      const stored = JSON.parse(safeStorage(localStorage, 'getItem', LAST_PRODUCT_KEY) || 'null');
      if (!stored?.url || !String(stored.url).includes('/products/')) return null;
      if (Date.now() - Number(stored.savedAt || 0) > 7 * 24 * 60 * 60 * 1000) return null;
      return stored;
    } catch (_) {
      return null;
    }
  }

  function hydrateProductReturnLinks() {
    const stored = getLastProductPage();
    let returnUrl = stored?.url || '';

    if (!returnUrl && document.referrer) {
      try {
        const referrer = new URL(document.referrer);
        if (referrer.origin === window.location.origin && referrer.pathname.includes('/products/')) {
          returnUrl = `${referrer.pathname}${referrer.search}`;
        }
      } catch (_) {}
    }

    if (!returnUrl) return;
    document.querySelectorAll('[data-bh-return-to-product]').forEach((link) => {
      link.href = returnUrl;
      link.dataset.bhReturnReady = 'true';
    });
  }

  function restoreProductPosition() {
    if (!productUrl()) return;
    const shouldRestore = safeStorage(sessionStorage, 'getItem', RETURN_PRODUCT_KEY);
    if (!shouldRestore) return;
    safeStorage(sessionStorage, 'removeItem', RETURN_PRODUCT_KEY, null);

    const stored = getLastProductPage();
    if (!stored || stored.url.split('?')[0] !== window.location.pathname) return;
    window.setTimeout(() => window.scrollTo({ top: Number(stored.scrollY || 0), behavior: 'auto' }), 80);
  }

  const CART_TEXT = new Map([
    ['saving', 'Ahorras'],
    ['savings', 'Ahorras'],
    ['you save', 'Ahorras'],
    ['total', 'Subtotal'],
    ['total estimado', 'Total a pagar'],
    ['estimated total', 'Total a pagar']
  ]);

  function localizeCartText(root = document) {
    const scopes = [...(root.querySelectorAll?.(
      '#main-cart-items, #main-cart-footer, cart-items, cart-drawer, [class*="saving" i]'
    ) || [])];

    if (/\/cart\/?$/.test(window.location.pathname) && document.body) scopes.push(document.body);

    scopes.forEach(scope => {
      const walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT);
      const nodes = [];
      while (walker.nextNode()) nodes.push(walker.currentNode);

      nodes.forEach(node => {
        const original = node.nodeValue || '';
        const normalized = original.trim().toLowerCase().replace(/\s+/g, ' ');
        const replacement = CART_TEXT.get(normalized);
        if (!replacement) return;
        node.nodeValue = original.replace(original.trim(), replacement);
        if (replacement === 'Ahorras') node.parentElement?.classList.add('bh-cart-saving');
      });
    });
  }

  function syncFloatingCheckout() {
    const footer = document.querySelector('#main-cart-footer');
    const source = footer?.querySelector('.cart__ctas');
    let floating = document.querySelector('body > .bh-cart-floating-checkout');

    if (mobileQuery.matches && footer && !footer.classList.contains('is-empty')) {
      if (source) {
        if (floating && floating !== source) floating.remove();
        source.classList.add('bh-cart-floating-checkout');
        document.body.appendChild(source);
        floating = source;
      }
      document.body.classList.toggle('bh-cart-has-floating-checkout', Boolean(floating));
      return;
    }

    if (floating && footer) {
      footer.querySelector('.cart__blocks')?.appendChild(floating);
      floating.classList.remove('bh-cart-floating-checkout');
    }
    document.body.classList.remove('bh-cart-has-floating-checkout');
  }

  let frame = 0;
  const observer = new MutationObserver(() => {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(() => {
      localizeCartText();
      syncFloatingCheckout();
      hydrateProductReturnLinks();
    });
  });

  function initialize() {
    localizeCartText();
    syncFloatingCheckout();
    hydrateProductReturnLinks();
    restoreProductPosition();
    rememberProductPage();
    observer.disconnect();
    observer.observe(document.body, { childList: true, subtree: true });
  }

  mobileQuery.addEventListener?.('change', syncFloatingCheckout);
  document.addEventListener('bh:variant:change', (event) => {
    rememberProductPage(event.detail?.variant?.id);
  });
  document.addEventListener('click', (event) => {
    if (!event.target.closest('[data-bh-return-to-product]')) return;
    safeStorage(sessionStorage, 'setItem', RETURN_PRODUCT_KEY, 'true');
  });
  window.addEventListener('pagehide', () => rememberProductPage());

  window.BHCartUI = { version: '2026.08.22.1', refresh: initialize };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();
